import isNumber from 'lodash/isNumber';

const getData = ({ from, to, template, ignores = [], column, keepFalsy }) => {
  let result = [];
  let i = from;
  while (i <= to) {
    if (keepFalsy) {
      if (!ignores.includes(i)) {
        result = [...result, template[`${column}${i}`] && template[`${column}${i}`].v ? isNumber(template[`${column}${i}`].v) ? Math.round(template[`${column}${i}`].v) : template[`${column}${i}`].v : 0];
      }
    } else {
      if (template[`${column}${i}`] && !ignores.includes(i)) {
        result = [...result, isNumber(template[`${column}${i}`].v) ? Math.round(template[`${column}${i}`].v) : template[`${column}${i}`].v];
      }
    }
    i += 1;
  }
  return result;
}

export default (template, numRows = 0) => {
  const brands = getData({ from: 2, to: numRows, template, column: 'A' });
  const industries = getData({ from: 2, to: numRows, template, column: 'B' });
  const categories = getData({ from: 2, to: numRows, template, column: 'C' });
  const volumes = getData({ from: 2, to: numRows, template, column: 'D' });
  return {
    brands,
    industries,
    categories,
    volumes,
  };
};
